export default __webpack_public_path__ + "static/card-icon-a04d633f7844df0753ac2e72273a7ccb.png";